export default __webpack_public_path__ + "static/media/RistekLogo-2026.1f504684.svg";